var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilldotcomLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1021_74083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8976 20.6581C10.8976 21.4744 10.2047 22.1651 9.38583 22.1651H5.03937V13.4372H9.38583C10.2047 13.4372 10.8976 14.1279 10.8976 14.9442V20.6581ZM5.03937 8.66512V0H0V27H10.5827C13.5433 27 16 24.4884 16 21.3488V14.3163C16 11.1767 13.6063 8.66512 10.5827 8.66512H5.03937Z",
    fill: "#FF5A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42529 7.15795V0.250977L13.2284 5.4626C15.5592 7.28354 16.0001 9.98353 16.0001 9.92074C14.4883 8.03702 12.4095 7.15795 11.0237 7.15795H6.42529Z",
    fill: "#FF9C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1021_74083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 27,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilldotcomLogo);
export default __webpack_public_path__ + "static/media/BilldotcomLogo.69684805f4a073c325c43c3cfc361a06.svg";
export { ForwardRef as ReactComponent };